import Request from '@/plugins/request';

export function getAdviceApplies(params) {
  return Request.get('advice-applies', { params })
}

export function createAdviceApply() {
  return Request.get(`advice-applies/create`)
}

export function storeAdviceApply(data) {
  return Request.post('advice-applies', data)
}

export function updateAdviceApply(id, data) {
  return Request.put(`advice-applies/${id}`, data)
}

export function editAdviceApply(id) {
  return Request.get(`advice-applies/${id}/edit`)
}

export function destroyAdviceApply(id) {
  return Request.delete(`advice-applies/${id}`)
}

export function changeAdviceStatus(data) {
  return Request.post(`advice-applies/change-advice-status`, data)
}

export function exportAdvanceApplies(params) {
  return Request.get('advice-applies/export', { params })
}
